export default "__VITE_ASSET__BxY6ril6__"